import { axiosPrivate } from "../api/axios";
import useRefreshToken from "./useRefreshToken";
import useAuth from "./useAuth";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom"; // or 'react-router-dom' if you're using react-router

const useAxiosPrivate = () => {
  const refresh = useRefreshToken();
  const { auth, logout } = useAuth();
  const navigate = useNavigate(); // or useHistory() if you're using react-router-dom

  useEffect(() => {
    console.log(`In Axios private useEffect`);

    const requestIntercept = axiosPrivate.interceptors.request.use(
      (config) => {
        if (!config.headers['Authorization']) {
          config.headers['Authorization'] = `Bearer ${auth?.newAccessToken}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    const responseIntercept = axiosPrivate.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config;
        if (error?.response?.status === 401) {
          console.log('Unauthorized');
          // Navigate to login page
          logout();
          navigate('/login');
          return Promise.reject('Unauthorized');
        } else if (error?.response?.status === 403 && !prevRequest?.sent) {
          prevRequest.sent = true;
          const newAccessToken = await refresh();
          prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
          return axiosPrivate(prevRequest);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosPrivate.interceptors.request.eject(requestIntercept);
      axiosPrivate.interceptors.response.eject(responseIntercept);
    };
  }, [auth, refresh]);

  return axiosPrivate;
};

export default useAxiosPrivate;
